import { isPlatformBrowser } from '@angular/common';
import { Component, HostListener, Inject, Input, PLATFORM_ID } from '@angular/core';
import { CurrentTenantService } from '@suvo-bi-users';
import { IHeroBannerV3TileInstance } from '../../../../interfaces/tiles/definitions/hero-banner-v3-tile-definition.interface';
import {
  resolveSiteAssetCssValue,
  resolveSiteAssetUrl,
} from '../../../../utils/resolve-site-asset-url.util';

@Component({
  standalone: false,
  selector: 'suvo-bi-hero-banner-v3-tile',
  templateUrl: './hero-banner-v3-tile.component.html',
  styleUrls: ['./hero-banner-v3-tile.component.scss'],
})
export class HeroBannerV3TileComponent {
  private readonly mobileBreakpoint = 959;

  @Input() tileInstance: IHeroBannerV3TileInstance;

  isMobileScreen = false;

  private get siteBaseUrl(): string {
    return this.tenantService.currentTenantData?.primaryWebUrl ?? '';
  }

  get contentImgPath(): string {
    return resolveSiteAssetUrl(this.tileInstance?.contentImg ?? '', this.siteBaseUrl);
  }

  get backgroundStyle(): string {
    return resolveSiteAssetCssValue(this.tileInstance?.background ?? '', this.siteBaseUrl);
  }

  constructor(
    private readonly tenantService: CurrentTenantService,
    @Inject(PLATFORM_ID) private readonly platformId: object,
  ) {
    this.updateScreenSize();
  }

  @HostListener('window:resize')
  onWindowResize() {
    this.updateScreenSize();
  }

  scrollToElement(element) {
    element.scrollIntoView({
      behavior: 'smooth',
      block: 'start',
      inline: 'nearest',
    });
  }

  trackByIndex(index: number, item: any): number {
    console.log("item", item);
    console.log("index", index);
    return index;
  }

  private updateScreenSize() {
    if (!isPlatformBrowser(this.platformId)) {
      this.isMobileScreen = false;
      return;
    }

    this.isMobileScreen = window.innerWidth <= this.mobileBreakpoint;
  }
}
